// Footer link groups as an accordion on phones (under 900 px the CSS shows the toggle buttons and hides closed
// lists; from 900 px the buttons are hidden and every list shows). One delegated listener, so a group the theme
// editor re-renders keeps working. A group that holds the page you are on opens by itself.
const open = (group, state) => {
  group.classList.toggle('is-open', state);
  group.querySelector('[data-footer-toggle]')?.setAttribute('aria-expanded', String(state));
};

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-footer-toggle]');
  if (!button) return;
  const group = button.closest('.footer__group');
  if (group) open(group, !group.classList.contains('is-open'));
});

const init = (root = document) => {
  for (const link of root.querySelectorAll('.footer__group a[aria-current="page"]')) {
    const group = link.closest('.footer__group');
    if (group) open(group, true);
  }
};

init();
document.addEventListener('shopify:section:load', (event) => init(event.target));
